import { bsh_getAdminUserDetails, bsh_getInsuranceIoUserDetails } from "helpers/sf_browser_storage_helper";
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Formik Validation
import { Col, Form, Modal, ModalBody, Row, ModalHeader, ModalFooter, Collapse } from "reactstrap";
import { getApiDataById } from "store/admin/dev-dashboard/actions";
import ReqOrResTable from "./ReqOrResTable";


export const SECTION_NAMES = {
  REQUEST: "request",
  RESPONSE: "response",
}

const ReqAndResModal = ({ show: { active, row }, onClickCloseModal }) => {
  const dispatch = useDispatch();
  const insurance_io_user_token = bsh_getInsuranceIoUserDetails()?.token;
  const admin_user_token = bsh_getAdminUserDetails()?.token;

  const {
    api_timing_data_by_id,
    api_timing_data_by_id_loading,
    last_fetched_api_timing_data_id
  } = useSelector((state) => ({
    api_timing_data_by_id: state.DevDashboard.api_timing_data_by_id,
    api_timing_data_by_id_loading: state.DevDashboard.api_timing_data_by_id_loading,
    last_fetched_api_timing_data_id: state.DevDashboard.last_fetched_api_timing_data_id,
  }))

  useEffect(() => {
    if (row && last_fetched_api_timing_data_id !== row?.id) {
      dispatch(getApiDataById({ 
        id: row?.id,
        is_master: (insurance_io_user_token && (admin_user_token !== insurance_io_user_token)) ? 1 : 0
      }))
    }
  }, [row])

  const [sectionName, setSectionName] = useState({
    [SECTION_NAMES.REQUEST]: true,
    [SECTION_NAMES.RESPONSE]: false,
  });
  const [isBeautify, setIsBeautify] = useState(true);

  const handleSectionName = (name) => {
    if (name === SECTION_NAMES.REQUEST) {
      setSectionName({
        [SECTION_NAMES.REQUEST]: true,
        [SECTION_NAMES.RESPONSE]: false,
      });
      return;
    } else if (name === SECTION_NAMES.RESPONSE) {
      setSectionName({
        [SECTION_NAMES.REQUEST]: false,
        [SECTION_NAMES.RESPONSE]: true,
      });
      return;
    }
  };

  return (
    <Modal size="xl" isOpen={active} toggle={onClickCloseModal} centered={true}>
      <ModalHeader>
        <span className="modal-title mt-0">
          Request/Response Details
        </span>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onClickCloseModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={(e) => {
          e.preventDefault()
          return false;
        }}>
          <Row>
            <Col md={12}>
              <ul className="nav nav-tabs justify-content-between">
                <div className="d-flex">
                  <li className="nav-item">
                    <a className={`nav-link text-black hover-none text-capitalize ${sectionName[SECTION_NAMES.REQUEST] ? "active" : ""}`} onClick={() => handleSectionName(SECTION_NAMES.REQUEST)} aria-current={true}>{SECTION_NAMES.REQUEST}</a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link text-black hover-none text-capitalize ${sectionName[SECTION_NAMES.RESPONSE] ? "active" : ""}`} onClick={() => handleSectionName(SECTION_NAMES.RESPONSE)} aria-current={true}>{SECTION_NAMES.RESPONSE}</a>
                  </li>
                </div>
                <li className="nav-item d-flex align-items-center form-check form-switch form-switch-md">
                  <label className='font-weight-medium mb-0 me-2'>Beautify</label>
                  <input
                    name="beautify"
                    id="beautify"
                    type="checkbox"
                    className="form-check-input ms-3 my-auto"
                    checked={isBeautify}
                    onClick={() => setIsBeautify(!isBeautify)}
                  />
                </li>
              </ul>
            </Col>

            <Col md={12}>
              <div style={{ height: "390px" }}>
                <div className="accordion-item bg-white rounded border-0">
                  <Collapse isOpen={sectionName[SECTION_NAMES.REQUEST]} className="accordion-collapse">
                    <div className="accordion-body pt-3">
                      <ReqOrResTable
                        row={api_timing_data_by_id}
                        sectionName={SECTION_NAMES.REQUEST}
                        isBeautify={isBeautify}
                        loading={api_timing_data_by_id_loading}
                      />
                    </div>
                  </Collapse>
                  <Collapse isOpen={sectionName[SECTION_NAMES.RESPONSE]} className="accordion-collapse">
                    <div className="accordion-body pt-3">
                      <ReqOrResTable
                        row={api_timing_data_by_id}
                        sectionName={SECTION_NAMES.RESPONSE}
                        isBeautify={isBeautify}
                        loading={api_timing_data_by_id_loading}
                      />
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <div className="mt-4 float-end">
          <button type="button" className="btn btn-light ms-2" name="close" onClick={onClickCloseModal}>
            Close
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

ReqAndResModal.propTypes = {
  onClickCloseModal: PropTypes.func,
  show: PropTypes.object,
}

export default ReqAndResModal;
